import type { ReactNode } from "react";

/**
 * 嵌入端的状态提示（设计 §13）。
 *
 * 刻意不复用独立端的 `StatusPage` / `AdmissionNotice`：那些是整页尺度的排版，
 * 塞进宿主页面里的一个框会显得空旷。这里按 iframe 的可用高度做紧凑版式。
 */
export function EmbeddedNotice({ title, detail, actions }: { title: string; detail: string; actions?: ReactNode }) {
  return (
    <div className="grid h-full min-h-60 place-items-center bg-background px-6 py-10">
      <section className="w-full max-w-100 text-center">
        <h1 className="text-base font-semibold text-foreground">{title}</h1>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">{detail}</p>
        {actions ? <div className="mt-5 flex justify-center gap-2">{actions}</div> : null}
      </section>
    </div>
  );
}
